import React, { useContext } from 'react';
import { FaPlay, FaPause } from 'react-icons/fa';
import { Slider } from 'antd';
import { ColorContext } from 'App';
import { sizing } from '@mui/system';

export default function Controls({ isPlaying, setIsPlaying, playbackSpeed, setPlaybackSpeed }) {
  const theme = useContext(ColorContext);
  const button = (speed) => ({
    backgroundColor: playbackSpeed === speed ? theme.primaryHighlight : 'transparent',
  });

  const btnClass = `px-1 rounded`;
  return (
    <div className="text-nowrap overflow-hidden">
      <button className="align-self-center me-1" onClick={() => setIsPlaying(!isPlaying)}>
        {isPlaying ? <FaPause size={'1rem'} /> : <FaPlay size={'1rem'} />}
      </button>
      <button className={btnClass} style={button(0.25)} onClick={() => setPlaybackSpeed(0.25)}>
        .25x
      </button>
      <button className={btnClass} style={button(0.5)} onClick={() => setPlaybackSpeed(0.5)}>
        .5x
      </button>
      <button className={btnClass} style={button(1)} onClick={() => setPlaybackSpeed(1)}>
        1x
      </button>
      <button className={btnClass} style={button(1.5)} onClick={() => setPlaybackSpeed(1.5)}>
        1.5x
      </button>
      <button className={btnClass} style={button(3)} onClick={() => setPlaybackSpeed(3)}>
        3x
      </button>
      <button className={btnClass} style={button(5)} onClick={() => setPlaybackSpeed(5)}>
        5x
      </button>
      <button className={btnClass} style={button(10)} onClick={() => setPlaybackSpeed(10)}>
        10x
      </button>
      {/* <h1
        style={{
          marginLeft: 10,
          alignSelf: "center",
          fontSize: preview ? 25 : 30,
        }}
      >
        {frames[sliderValue].toLocaleTimeString(undefined, {
          hour: "2-digit",
          minute: "2-digit",
        })}
      </h1> */}
    </div>
  );
}
